export default __webpack_public_path__ + "static/media/icn_arrow_big.f690a91b.svg";